// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "../../../components/MDBox";

// NewProduct page components
import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";

export default function RealCostingInfos({
  deviceId,
  price,
  setPrice,
  realPurchases,
  setRealPurchases,
  hoursPast,
  setHoursPast,
  hoursPlanned,
  setHoursPlanned,
}) {
  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <FormField
            inputProps={{ maxLength: 255 }}
            value={price}
            onChange={(event) => setPrice(event.target.value)}
            required
            variant="standard"
            type="number"
            label="Prix de vente de l'appareil"
          />
        </Grid>
        <Grid item xs={4}>
          <FormField
            inputProps={{ maxLength: 255 }}
            value={realPurchases}
            onChange={(event) => setRealPurchases(event.target.value)}
            required
            variant="standard"
            type="number"
            label="Coût réel des achats"
          />
        </Grid>
        <Grid item xs={4}>
          <FormField
            inputProps={{ maxLength: 255 }}
            value={hoursPast}
            onChange={(event) => setHoursPast(event.target.value)}
            required
            variant="standard"
            type="number"
            label="Nombre d'heures passées"
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}
